import { MatTableDataSourceBackendExtended } from "@comunicare/comunicare-angular-interfaces";
import { IDataSourceBackendParam, IStatEvent, IStatEventView } from "@comunicare/comunicare-interfaces";
import { Observable, of } from "rxjs";
import { UserStatisticsApiService } from "src/app/providers/api/userStatistics-api.service";

export class StatEventsDataSource extends MatTableDataSourceBackendExtended<IStatEvent> {
  constructor(private statEventApi: UserStatisticsApiService, private includePrivateLogs = false) {
    super();
  }

  public data(params: IDataSourceBackendParam): Observable<IStatEventView[]> {
    return this.statEventApi.listStatEvents(params, params.services, this.includePrivateLogs) as Observable<IStatEventView[]>;
  }
  protected dataCount(_param: IDataSourceBackendParam): Observable<number> {
    /*
      Use this, the day we decide to make the page implements AbstractBackendTablePage
      return this.statEventApi
        .countStatEvents(param.filters, param.lang, param.services).pipe(map((response) => response.count));
    */
    return of(0);
  }
}
